import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ReportsService } from 'src/app/services/reports.service';
import { Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-je-activity',
  templateUrl: './je-activity.component.html',
  styleUrls: ['./je-activity.component.scss']
})
export class JeActivityComponent implements OnInit {
  public userRidList: any = [];
  public appTypeList: any = [];
  public financialYearList: any = [];

  public selectedUserRid: any;
  public selectedAppType: any;
  public selectedFinancialYear: any;
  selectedApplications: any[];
  public tableData: any = [];
  public userId: any;

  public subscriptions: any = [];
  public subjectSub: any;
  public loading: boolean = false;
  public showTable: boolean = false;

  constructor(
    private http: HttpClient,
    private deptDashBoardService: DepartmentDashboardService,
    private loader: AppLoaderService,
    private messageService: MessageService,
    private reportsService: ReportsService,
    private router: Router,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.getAppTypeList();
      this.getFinancialYearList();
    }, 200);

    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.loadData();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  loadData() {
    this.loader.start();
    let sub = this.deptDashBoardService
      .getActiveUserIDsByGeoCodes(this.userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (`${data}`?.length > 0) {
            this.userRidList = data;
          } else {
            this.userRidList = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `${data}`,
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.userRidList = [];
          this.messageService.add({
            severity: 'info',
            summary: 'Info Message',
            detail: `${err}`,
          });
        },
      });

    this.subscriptions.push(sub);
  }


  getAppTypeList() {
    this.appTypeList = [
      { status_Code: 1, status_Description: 'Pending' },
      { status_Code: 2, status_Description: 'Current' },
      { status_Code: 3, status_Description: 'Approved' }
    ];
  }

  getFinancialYearList(){
    this.reportsService.getFinanacialYearList()
    .pipe(first())
    .subscribe({
      next: (data) => {
        this.financialYearList = data;
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'error Message',
          detail: `${err}`,
        });
      }
    })
  }

  fetchData() {
    if (this.selectedUserRid && this.selectedAppType && this.selectedFinancialYear) {
      this.getDataToShow();
      this.showTable = true;
    } else {
      this.showTable = false;
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: `Select the value from the dropdown`,
      });
    }
  }

  getDataToShow() {
    // this.loader.start();
    this.loading = true;
    let sub = this.deptDashBoardService
      .getApplicationsForPhysicalVerification(
        this.selectedUserRid.UserID,
        this.selectedAppType.status_Description,
        this.selectedFinancialYear.FinancialYears)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          if (`${data}`?.length > 0) {
            this.tableData = data;
          } else {
            this.tableData = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `${data}`,
            });
          }
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.tableData = [];
          this.messageService.add({
            severity: 'info',
            summary: 'Info Message',
            detail: `${err}`,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  onClickApp(appId) {
    // let statusCodeEncrypted = this.cryptoJsService.Encrypt(this.statusCode);
    const link = this.router.serializeUrl(this.router.createUrlTree(['xen', 'print', appId]));
    window.open(link, '_blank');
  }
}
